(function () {
  'use strict';

  angular
    .module('web2print')
    .factory('ParcelTypes', ParcelTypes);

  ParcelTypes.$inject = ['$http', '$translate', '$q'];

  /* @ngInject */
  function ParcelTypes ($http, $translate, $q) {
    const service = {
      get: get
    };

    return service;


    function get (toCountry, language) {
      const from = 'SE'; // We only support sending from Sweden at the moment
      const to = toCountry ? toCountry : 'SE';
      const lang = language || 'sv';

      const params = '?fromCountry=' + from + '&toCountry=' + to + '&language=' + lang;

      return $http.get(web2print.env.productsUrl + params).then(function (response) {
        console.log('ParcelTypes : get : response', response);
        return response.data.products;
      });
    }
  }
})();
